<section class="py-5">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-12 col-md-10 col-lg-8">
				<div class="card shadow-sm border-0">
					<div class="card-body text-center">
						@if (mobileType === "android") {
							<div class="mb-3" aria-hidden="true">
								<span
									class="material-symbols-sharp text-success"
									style="font-size: 48px; line-height: 1"
									>android</span
								>
							</div>
							<h1 class="h3 mb-2">Android Tablet Installation</h1>
							<p class="text-muted mb-4">
								Install this app for a full-screen, offline-capable
								experience.
							</p>
							<button
								mat-raised-button
								color="primary"
								(click)="installPwa()"
							>
								Add to Home screen
							</button>
						} @else if (mobileType === "ios") {
							<div class="mb-3" aria-hidden="true">
								<span
									class="material-symbols-sharp text-primary"
									style="font-size: 48px; line-height: 1"
									>tablet_mac</span
								>
							</div>
							<h1 class="h3 mb-2">iPad Installation</h1>
							<p class="text-muted mb-4">
								Tap the Share button, then "Add to Home Screen".
							</p>
							<div
								class="d-flex align-items-center justify-content-center flex-wrap"
							>
								<img
									class="img-fluid mx-2"
									style="max-height: 56px"
									src="./assets/img/ios-menu-btn.png"
									alt="Share button"
								/>
								<span class="material-symbols-sharp mx-1"
									>navigate_next</span
								>
								<img
									class="img-fluid mx-2"
									style="max-height: 56px"
									src="./assets/img/ios-add-btn.png"
									alt="Add to Home Screen button"
								/>
							</div>
						} @else {
							<h1 class="h4 mb-2">Open on a tablet</h1>
							<p class="text-muted mb-0">
								Access this page on an Android tablet or iPad to install
								the app.
							</p>
						}
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
